var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2A35",
    fillRule: "evenodd",
    d: "M10.99 10.324h.742l3.98 3.998a.991.991 0 0 1 0 1.399.991.991 0 0 1-1.399 0l-3.989-3.989v-.741l-.253-.263a6.1 6.1 0 0 1-5.012 1.389C2.45 11.676.367 9.498.048 6.87A6.105 6.105 0 0 1 6.87.048c2.627.319 4.805 2.402 5.246 5.011a6.1 6.1 0 0 1-1.39 5.012l.264.253ZM1.879 6.101A4.218 4.218 0 0 0 6.1 10.324a4.218 4.218 0 0 0 4.223-4.223 4.218 4.218 0 0 0-4.223-4.223A4.218 4.218 0 0 0 1.878 6.1Z",
    clipRule: "evenodd"
  })));
};
export default SvgSearch;